var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.488 2a1 1 0 10-2 0v12.582l-3.28-3.288a1 1 0 00-1.416 1.412l4.988 5a1 1 0 00.708.294c.283 0 .54-.118.721-.308l4.974-4.986a1 1 0 00-1.416-1.412l-3.28 3.287V2z",
    fill: "#000"
  })));
}
export default SvgIconArrowDown;